(function () {
    'use strict';

    angular.module('iMatApp')
        .factory('upload3DModelAccessManager', accessManager);

    accessManager.$inject = ['$q', '$log', 'mainWorkspace', 'upload3DModelPermissionsService'];

    function accessManager($q, $log, mainWorkspace, permissionsService) {

        var lastRequestCanceler = null;

        var service = {
            runProductTemplateWatching: runProductTemplateWatching
        };

        return service;

        // --------------------------------------------------------------------------------------------------------------------

        function runProductTemplateWatching($scope) {
            $scope.$watch(function () {
                return mainWorkspace.product.productTemplateId;
            }, productTemplateChanged);
        }

        function productTemplateChanged(newProductTemplateId) {
            if (!newProductTemplateId) {
                return;
            }

            if (lastRequestCanceler) {
                lastRequestCanceler.resolve('CANCELED');
            }
          
            lastRequestCanceler = $q.defer();

            permissionsService.getPermissions(newProductTemplateId, lastRequestCanceler.promise)
                .then(function (permissions) {
                    mainWorkspace.product.permissions = permissions;
                    $log.debug("Set permissions by productTemplateId=" + newProductTemplateId, permissions);
                })
                .catch(function (reason) {
                    if (reason === "CANCELED") {
                        return $q.reject(reason);
                    }

                    mainWorkspace.product.permissions = {
                        scaleReadOnly: true
                    };

                    throw new Upload3DModelGeneralError('Getting permissions failed.', reason);
                })
                .finally(function () {
                    lastRequestCanceler.reject();
                    lastRequestCanceler = null;
                });
        }
    }
})();